import React, { useEffect, useState } from 'react';
import {Modal, Input, Table, Pagination, Space, Select} from 'antd';
import {ColumnsType} from "antd/es/table";
import {getCharacterOutfitItemsByCharacterId, getCharacterOutfits} from "../../helpers/api/character";

const { Search } = Input;


interface OutfitItemModel {
    key: React.Key;
    id: string;
    name: string;
    imageUrl: string;
}


const OutfitSelectionModal = (
    {
        open,
        onClose,
        onConfirm = (outfitItem :  any) => {},
        characterId,
    } :  any
) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [filters, setFilters] = useState({
        search: '',
        characterOutfitId: '',
    });

    const [outfits, setOutfits] = useState([]);

    useEffect(() => {
        if (open) {
            fetchOutfits();
        }
    }
    , [open]);

    const fetchOutfits = async () => {
        try {
            if (!characterId) {
                characterId = 'c90b6096-977f-4ca6-883d-878af08d33d9';
            }
            const response = await getCharacterOutfits(characterId, {
                pageIndex: currentPage - 1,
                pageSize,
            });
            setOutfits(response.data.data);
        } catch (err) {
            console.error('Failed to fetch outfits:', err);
        }
    }

    // Columns cho Table
    const columns :  ColumnsType<OutfitItemModel> = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span>{text}</span>
                    </div>
                );
            }
        },
        {
            title: 'Image',
            dataIndex: 'imageUrl',
            key: 'imageUrl',
            render: (text, record, index) => {
                return (
                        <img
                            src={record.imageUrl || 'https://via.placeholder.com/40'}
                            alt={record.name}
                            style={{ width: 40, height: 40, marginRight: 10 }}
                        />

                );
            }
        },
    ];

    // Fetch data
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getCharacterOutfitItemsByCharacterId(characterId, {
                name: filters.search,
                characterOutfitId: filters.characterOutfitId,
                pageIndex: currentPage - 1,
                pageSize,
            });
            setData(response.data.data);
            setTotal(response.data.totalRecord);
        } catch (err) {
            console.error('Failed to fetch outfit items:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            fetchData();
        }
    }, [open, filters, currentPage, pageSize]);

    return (
        <Modal
           open={open}
            title="Select outfit item"
            onCancel={onClose}
            footer={null}
            width={700}
        >
            <Space style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                <Search
                    placeholder="Search outfit item"
                    onSearch={(value) => setFilters({ ...filters, search: value })}
                    style={{ width: 400 }}
                />
                <Select
                    style={{ width: 200 }}
                    placeholder="Select outfit"
                    onChange={(value) => {
                        setFilters({ ...filters, characterOutfitId: value });
                    }}
                >
                    {outfits.map((outfit: any) => (
                        <Select.Option key={outfit.id} value={outfit.id}>
                            {outfit.name}
                        </Select.Option>
                    ))}
                </Select>


            </Space>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={false}
                onRow={(record) => ({
                    onClick: () => {
                        onConfirm(record);
                        onClose();
                    },
                })}
                rowClassName={() => 'clickable-row'}
                style={{ cursor: 'pointer', maxHeight: 400, overflowY: 'auto' }}
            />

            <Pagination
                style={{ marginTop: 16, textAlign: 'right' }}
                current={currentPage}
                pageSize={pageSize}
                total={total}
                onChange={(page, pageSize) => {
                    setCurrentPage(page);
                    setPageSize(pageSize);
                }}
                showSizeChanger
            />
        </Modal>
    );
};

export default OutfitSelectionModal;
